import { BulletListDropdown } from './BulletListDropdown'
import { CheckListButton } from './CheckListButton'
import { NumberedListDropdown } from './NumberedListDropdown'
import { ToggleBlockButton } from './ToggleBlockButton'

export const ListsOptions = () => {
  return (
    <>
      <BulletListDropdown />
      <NumberedListDropdown />
      <CheckListButton />
      <ToggleBlockButton />
    </>
  )
}
